var map = {
	"./alert-sign.svg": 108,
	"./arrow-down-circle.svg": 122,
	"./arrow-input-grey.svg": 110,
	"./arrow-input-white.svg": 111,
	"./arrow-right-blue.svg": 37,
	"./arrow-right-green.svg": 53,
	"./arrow-right-grey.svg": 52,
	"./arrow-right-orange.svg": 59,
	"./arrow-right.svg": 123,
	"./back-arrow.svg": 98,
	"./calendar-arrow-back-double.svg": 42,
	"./calendar-arrow-back.svg": 43,
	"./campaign-pause.svg": 103,
	"./campaign-play.svg": 104,
	"./campaign-stop.svg": 105,
	"./checkbox-content.svg": 58,
	"./checkmark-done-circle.svg": 207,
	"./clip-blue.svg": 208,
	"./clip-grey.svg": 112,
	"./clock.svg": 209,
	"./copy-white.svg": 107,
	"./copy.svg": 113,
	"./cross-grey.svg": 210,
	"./cross.svg": 50,
	"./dashboard-api.svg": 124,
	"./dashboard-create.svg": 125,
	"./dashboard-faq.svg": 126,
	"./dashboard-send.svg": 127,
	"./dashboard-templates.svg": 128,
	"./double-check.svg": 129,
	"./download.svg": 114,
	"./drag-and-drop-image.svg": 130,
	"./dropdown-arrow.svg": 115,
	"./edit.svg": 211,
	"./empty-avatar.svg": 116,
	"./envelope-b.svg": 212,
	"./envelope-w.svg": 213,
	"./external-link.svg": 117,
	"./eye-clear.svg": 51,
	"./eye-off.svg": 56,
	"./eye-on.svg": 57,
	"./header-navbar-item-corner.svg": 131,
	"./help-circle.svg": 100,
	"./mail-grey.svg": 132,
	"./menu-01-address-book-b.svg": 214,
	"./menu-01-address-book-w.svg": 215,
	"./menu-02-campaign-b.svg": 216,
	"./menu-02-campaign-w.svg": 217,
	"./menu-03-statistics-b.svg": 218,
	"./menu-03-statistics-w.svg": 219,
	"./menu-04-pricing-b.svg": 220,
	"./menu-04-pricing-w.svg": 221,
	"./menu-05-api-b.svg": 222,
	"./menu-05-api-w.svg": 223,
	"./menu-06-more-b.svg": 224,
	"./menu-06-more-w.svg": 225,
	"./menu-07-sender-ids-b.svg": 226,
	"./menu-07-sender-ids-w.svg": 227,
	"./menu-right.svg": 133,
	"./more.svg": 102,
	"./navbar-api-dark.svg": 134,
	"./navbar-api-orange.svg": 135,
	"./navbar-balance-dark.svg": 136,
	"./navbar-balance-orange.svg": 137,
	"./navbar-barred-list-dark.svg": 138,
	"./navbar-barred-list-orange.svg": 139,
	"./navbar-company-dark.svg": 140,
	"./navbar-company-orange.svg": 141,
	"./navbar-detailed-dark.svg": 142,
	"./navbar-detailed-orange.svg": 143,
	"./navbar-faq-dark.svg": 144,
	"./navbar-faq-orange.svg": 145,
	"./navbar-hlr-dark.svg": 146,
	"./navbar-hlr-orange.svg": 147,
	"./navbar-incoming-messages-dark.svg": 148,
	"./navbar-incoming-messages-orange.svg": 149,
	"./navbar-invoices-dark.svg": 150,
	"./navbar-invoices-orange.svg": 151,
	"./navbar-logs-dark.svg": 152,
	"./navbar-logs-orange.svg": 153,
	"./navbar-managers-dark.svg": 154,
	"./navbar-managers-orange.svg": 155,
	"./navbar-moderation-dark.svg": 156,
	"./navbar-moderation-orange.svg": 157,
	"./navbar-my-account-dark.svg": 158,
	"./navbar-my-account-orange.svg": 159,
	"./navbar-password-dark.svg": 160,
	"./navbar-password-orange.svg": 161,
	"./navbar-payment-pending-dark.svg": 162,
	"./navbar-payment-pending-orange.svg": 163,
	"./navbar-pricing-dark.svg": 164,
	"./navbar-pricing-orange.svg": 165,
	"./navbar-regular-dark.svg": 166,
	"./navbar-regular-orange.svg": 167,
	"./navbar-reports-dark.svg": 168,
	"./navbar-reports-orange.svg": 169,
	"./navbar-rules-dark.svg": 170,
	"./navbar-rules-orange.svg": 171,
	"./navbar-scheduled-dark.svg": 172,
	"./navbar-scheduled-orange.svg": 173,
	"./navbar-sender-dark.svg": 174,
	"./navbar-sender-orange.svg": 175,
	"./navbar-sent-dark.svg": 176,
	"./navbar-sent-orange.svg": 177,
	"./navbar-services-dark.svg": 178,
	"./navbar-services-orange.svg": 179,
	"./navbar-shorten-link-dark.svg": 180,
	"./navbar-shorten-link-orange.svg": 181,
	"./navbar-statistics-hlr-dark.svg": 182,
	"./navbar-statistics-hlr-orange.svg": 183,
	"./navbar-subscribers-dark.svg": 184,
	"./navbar-subscribers-orange.svg": 185,
	"./navbar-summary-dark.svg": 186,
	"./navbar-summary-orange.svg": 187,
	"./navbar-templates-dark.svg": 188,
	"./navbar-templates-orange.svg": 189,
	"./navbar-two-factor-authentication-dark.svg": 190,
	"./navbar-two-factor-authentication-orange.svg": 191,
	"./navbar-visit-history-dark.svg": 192,
	"./navbar-visit-history-orange.svg": 193,
	"./navbar-white-list-dark.svg": 194,
	"./navbar-white-list-orange.svg": 195,
	"./options.svg": 228,
	"./plus-circle.svg": 229,
	"./plus-in-circle.svg": 118,
	"./pop-up-cross.svg": 54,
	"./redirect.svg": 230,
	"./refresh.svg": 119,
	"./rounded-polygon.svg": 109,
	"./search-blue.svg": 196,
	"./search-white.svg": 197,
	"./search.svg": 231,
	"./select-dropdown-arrow.svg": 55,
	"./selected-option-marker.svg": 232,
	"./send-white.svg": 198,
	"./sliders.svg": 233,
	"./social-media-facebook.svg": 199,
	"./social-media-linkedin.svg": 200,
	"./social-media-twitter.svg": 201,
	"./social-media-whats-app.svg": 202,
	"./sort-down.svg": 120,
	"./sort-up.svg": 121,
	"./steps-check.svg": 99,
	"./support-clock-icon.svg": 203,
	"./support-mail-icon.svg": 204,
	"./support-phone-icon.svg": 205,
	"./toggle-notifications-b.svg": 234,
	"./toggle-notifications-w.svg": 235,
	"./toggle-profile-b.svg": 236,
	"./toggle-sliders-b.svg": 237,
	"./toggle-sliders-w.svg": 238,
	"./toggle-support-b.svg": 239,
	"./toggle-support-w.svg": 240,
	"./trash.svg": 106,
	"./ui-status-error.svg": 60,
	"./ui-status-success.svg": 61,
	"./uploading-cloud.svg": 101,
	"./user-plus-dark.svg": 241,
	"./user-plus.svg": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;